import React from 'react';
import { Navigate } from 'react-router-dom';
import useCurrentUser from '../hooks/useCurrentUser';

export default function PermissionRoute({ permission, children }) {
  const { permissions, loading } = useCurrentUser();

  if (loading) return null;

  if (!permissions.includes(permission)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
